import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()
const TRAINING="training"
const COURSE=`${TRAINING}/courses`
const PLATFORMS=`${TRAINING}/platforms`
const CATEGORY=`${TRAINING}/category`
const COLLABORATOR=`${TRAINING}/collaborator`
const COLLABORATOR_LIST=`${TRAINING}/collaborator/list`
const ANNUAL_PLAN=`${TRAINING}/annual_plan`
const ANNUAL_PLAN_AREAS=`${TRAINING}/annual_plan/areas`
const STATISTICS=`${TRAINING}/statistics`

//courseG
export const courseGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(COURSE,{params,signal:controller.signal})
    return {call,controller}
}
export const coursePost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(COURSE,data,{params,signal:controller.signal})
    return {call,controller}
}
export const courseIdGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${COURSE}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
export const courseIdPut = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${COURSE}/${id}`,data,{params,signal:controller.signal})
    return {call,controller}
}

//Collaborator
export const courseCollaboratorGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(COLLABORATOR,{params,signal:controller.signal})
    return {call,controller}
}
export const courseCollaboratorPost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(COLLABORATOR,data,{params,signal:controller.signal})
    return {call,controller}
}
export const courseCollaboratorIdGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${COLLABORATOR}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
export const courseCollaboratorIdPut = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${COLLABORATOR}/${id}`,data,{params,signal:controller.signal})
    return {call,controller}
}
export const courseCollaboratorIdDelete = (id,params) => {
    const controller= loadAbort()
    const call= axios.delete(`${COLLABORATOR}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
//CollaboratorList
export const courseCollaboratorListGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${COLLABORATOR_LIST}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
//category
export const categoryGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(CATEGORY,{params,signal:controller.signal})
    return {call,controller}
}
export const categoryIdGet = (id,params) => {
    const controller= loadAbort()
    const call= axios.get(`${CATEGORY}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
//anual plan
export const annualPlanGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(ANNUAL_PLAN,{params,signal:controller.signal})
    return {call,controller}
}
export const annualPlanPost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(ANNUAL_PLAN,data,{params,signal:controller.signal})
    return {call,controller}
}
export const annualPlanDelete = (params) => {
    const controller= loadAbort()
    const call= axios.delete(ANNUAL_PLAN,{params,signal:controller.signal})
    return {call,controller}
}
export const annualPlanIdDelete = (id,params) => {
    const controller= loadAbort()
    const call= axios.delete(`${ANNUAL_PLAN}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
export const annualPlanAreasGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(ANNUAL_PLAN_AREAS,{params,signal:controller.signal})
    return {call,controller}
}

// statistics
export const statisticsGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(STATISTICS,{params,signal:controller.signal})
    return {call,controller}
}

//platform
export const platformGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(PLATFORMS,{params,signal:controller.signal})
    return {call,controller}
}
export const platformPost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(PLATFORMS,data,{params,signal:controller.signal})
    return {call,controller}
}